<div class="header">
  <h2>{{ 'AI_ASSISTANT.MCP.IMPORT' | translate }}</h2>
  <button (click)="export()" mat-stroked-button>
    <mat-icon>download</mat-icon>{{ 'AI_ASSISTANT.SHARED.DOWNLOAD_YAML' | translate }}
  </button>
</div>
<mat-dialog-content>
  @if (data.namespace; as ns) {
    @if (ns.globalNamespace || ns.systemNamespace) {
      <glxy-alert>
        Global and System resources are managed through
        <a href="https://github.com/vendasta/ai-assistants-config" target="_blank">Git</a>. To save changes, download
        the YAML file and update the file in the ai-assistants-config repo.
        <a
          target="_blank"
          [href]="'https://github.com/vendasta/ai-assistants-config/blob/master/' + data.mcp?.sourcePath"
          >View on GitHub</a
        >
      </glxy-alert>
    }
  }
  <mat-stepper linear="true" #stepper [labelPosition]="'bottom'">
    <mat-step [stepControl]="form.control">
      <ng-template matStepLabel>{{ 'AI_ASSISTANT.MCP.FIND_TOOLS' | translate }}</ng-template>
      <ng-template matStepContent>
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.MCP.NAME' | translate }}</glxy-label>
          <input type="text" matInput [formControl]="form.name" />
          @if (form.name?.errors?.pattern) {
            <glxy-error>{{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.NAME_PATTERN_ERROR' | translate }}</glxy-error>
          }
        </glxy-form-field>
        <glxy-form-field>
          <glxy-label>{{ 'AI_ASSISTANT.MCP.URL' | translate }}</glxy-label>
          <input type="text" matInput [formControl]="form.url" />
        </glxy-form-field>
        <glxy-form-field>
          <mat-checkbox [formControl]="form.prefixToolNames">
            <glxy-label>{{ 'AI_ASSISTANT.MCP.PREFIX_TOOLS' | translate }}</glxy-label>
          </mat-checkbox>
        </glxy-form-field>

        @if (data.namespace; as ns) {
          @if (ns.globalNamespace || ns.systemNamespace) {
            <ai-tool-auth-strategy-form [form]="form.authStrategy"></ai-tool-auth-strategy-form>
          }
        }

        <div class="headers">
          <div class="parameters-header">
            {{ 'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS' | translate }}
            <mat-icon
              class="info-icon"
              [glxyTooltip]="'AI_ASSISTANT.FUNCTIONS.CREATE_FUNCTION.HEADERS_HELP_TEXT' | translate"
            >
              info_outline
            </mat-icon>
          </div>
          <ai-tool-header-form-array [forms]="form.headers" class="header-forms-array"></ai-tool-header-form-array>
        </div>
        <ai-constraints-field [constraintsForm]="form.constraints"></ai-constraints-field>
      </ng-template>
    </mat-step>
    <mat-step>
      <ng-template matStepLabel>{{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}</ng-template>
      <ng-template matStepContent>
        @if (functions?.length > 0) {
          @for (func of functions; track func; let i = $index) {
            <mat-checkbox
              [checked]="selectedFunctionIds?.has(func.id)"
              (change)="toggleFunctionSelection(func.id, $event.checked)"
            >
              <div class="list-item">
                <mat-icon class="capability-icon">offline_bolt</mat-icon>
                <div class="list-item-content">
                  <div class="list-item-title">{{ func.id }}</div>
                  <div class="list-item-description">{{ func.description }}</div>
                </div>
              </div>
            </mat-checkbox>
          }
        }
      </ng-template>
    </mat-step>
  </mat-stepper>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="this.dialogRef.close()">{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  @switch (stepper.selectedIndex) {
    @case (0) {
      <button [disabled]="!form.valid()" (click)="loadFunctions()" mat-raised-button color="primary">
        {{ 'AI_ASSISTANT.SHARED.NEXT' | translate }}
      </button>
    }
    @case (1) {
      @if (data.namespace; as ns) {
        @if (ns.globalNamespace || ns.systemNamespace) {
          <button (click)="exportAndClose()" color="primary" mat-raised-button>
            <mat-icon>download</mat-icon>{{ 'AI_ASSISTANT.SHARED.DOWNLOAD_YAML' | translate }}
          </button>
        } @else {
          <button color="primary" [disabled]="!functions?.length" (click)="saveMCP()" mat-raised-button>
            {{ 'AI_ASSISTANT.SHARED.SAVE' | translate }}
          </button>
        }
      }
    }
  }
</mat-dialog-actions>
